import { render, staticRenderFns } from "./dg-table.vue?vue&type=template&id=69bfbf35&scoped=true&"
import script from "./dg-table.vue?vue&type=script&lang=js&"
export * from "./dg-table.vue?vue&type=script&lang=js&"
import style0 from "./dg-table.vue?vue&type=style&index=0&id=69bfbf35&prod&scoped=true&lang=css&"
import style1 from "./dg-table.vue?vue&type=style&index=1&id=69bfbf35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bfbf35",
  null
  
)

export default component.exports